const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20futuristic%20city%20with%20flying%20vehicles%20at%20sunset%2C%20warm%20golden%20and%20amber%20lighting%2C%20film%20grain%20texture%2C%20sci-fi%20movie%20aesthetic%2C%20dramatic%20cinematography%2C%20rich%20contrast%2C%20atmospheric%20depth&width=800&height=500&seq=card-66-01&orientation=landscape',
    title: '星际征途：新纪元',
    tag: '科幻',
    rating: '9.8',
    desc: '人类文明在宇宙深处遭遇前所未有的挑战，一支精英舰队踏上了拯救文明的史诗征程。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20rainy%20night%20alley%20with%20detective%20silhouette%2C%20warm%20street%20lamp%20glow%2C%20film%20noir%20aesthetic%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20rich%20amber%20and%20dark%20tones%2C%20suspenseful%20mood&width=800&height=500&seq=card-66-02&orientation=landscape',
    title: '暗夜追踪',
    tag: '悬疑',
    rating: '9.6',
    desc: '一起离奇的连环案件，将警探卷入了一场猫鼠游戏般的极限追凶之旅。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20couple%20on%20rooftop%20overlooking%20city%20at%20golden%20sunset%2C%20warm%20soft%20lighting%2C%20romantic%20movie%20aesthetic%2C%20film%20grain%20texture%2C%20dreamy%20atmosphere%2C%20rich%20golden%20tones&width=800&height=500&seq=card-66-03&orientation=landscape',
    title: '遇见你的夏天',
    tag: '爱情',
    rating: '8.9',
    desc: '盛夏的城市里，两个素不相识的灵魂因一次意外邂逅而开启了最温暖的旅程。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20ancient%20Chinese%20warriors%20in%20bamboo%20forest%20with%20mist%2C%20golden%20sunlight%20filtering%20through%2C%20wuxia%20movie%20aesthetic%2C%20dramatic%20composition%2C%20rich%20amber%20and%20jade%20tones%2C%20poetic%20atmosphere&width=800&height=500&seq=card-66-04&orientation=landscape',
    title: '风云再起',
    tag: '武侠',
    rating: '9.3',
    desc: '乱世之中，一位隐世侠客为守护心中正义，重出江湖迎战黑暗势力。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20giant%20ship%20facing%20massive%20storm%20waves%20at%20sea%2C%20dramatic%20dark%20sky%20with%20lightning%2C%20disaster%20movie%20aesthetic%2C%20intense%20atmosphere%2C%20rich%20contrast%20lighting%2C%20epic%20scale&width=800&height=500&seq=card-66-05&orientation=landscape',
    title: '末日孤舰：重生',
    tag: '灾难',
    rating: '9.1',
    desc: '全球海平面剧变，一艘孤舰承载着人类最后的希望，在惊涛骇浪中寻找新生。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20magical%20floating%20islands%20with%20waterfalls%20in%20fantasy%20world%2C%20warm%20golden%20sunlight%2C%20animated%20movie%20aesthetic%2C%20whimsical%20atmosphere%2C%20rich%20amber%20and%20emerald%20tones%2C%20enchanting%20vibe&width=800&height=500&seq=card-66-06&orientation=landscape',
    title: '梦境奇缘',
    tag: '奇幻',
    rating: '8.9',
    desc: '一个普通少年意外闯入梦境世界，与奇幻生物一起踏上了拯救梦境的冒险之旅。',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            编辑团队每日精选优质影片，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {cards.map((item) => (
            <article
              key={item.title}
              className="group bg-background-100 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-accent-500 text-background-50 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-50/90 rounded-full px-2.5 py-1">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs font-bold text-foreground-950 whitespace-nowrap">{item.rating}</span>
                </div>
              </div>

              <div className="p-5">
                <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/60">
                  <span className="text-xs text-foreground-400">六六影院电影大全收录</span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                    立即观看
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}